class ProductMonogramming extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.currentStep = "intro-1"
  }

  setupListeners () {
    super.setupListeners()

    this.els.stepChange.elements.forEach(el => {
      this.listeners.add(el, 'click', this.handleStepChange.bind(this))
    })

    this.listeners.add(this.els.form.element, 'submit', this.onSubmitHandler.bind(this))

    this.listeners.add(this.externalEls.trigger.element, 'click', this.setVariant.bind(this))
  }

  handleStepChange (e) {
    e.preventDefault()
    const trigger = e.target.closest('button')
    const step = trigger.dataset.step

    // Validation here

    this.currentStep = step
  }

  async onSubmitHandler (e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    if (this._isSubmitting) {
      return false
    }

    const hasSecondItem = this.externalEls['item-2-preview']?.element?.dataset.active === 'true'

    if (!hasSecondItem) {
      this.querySelectorAll('[data-step="intro-2"] input, [data-step="placement-2"] input').forEach(input => {
        input.disabled = true
      })
    }

    await this.addToCart()

    this.resetForm()

    return false
  }

  async addToCart () {

    if (this._isSubmitting) {
      return
    }

    this._isSubmitting = true

    const submitButton = this.querySelector('button[type="submit"]')
    if (submitButton) {
      submitButton.disabled = true
    }

    this.els.uuid.element.value = new Date().valueOf()

    try {
      await this.uploadPreviewImages()

      return await window.BAO.Cart.addItemFromForm(this.els.form.element)
    } finally {
      this._isSubmitting = false
      if (submitButton) {
        submitButton.disabled = false
      }
    }
  }

  async uploadPreviewImages () {
    const form = this.els.form.element
    const previewInputs = form.querySelectorAll('[name^="items["][name$="][_preview_image]"]')

    await Promise.all(Array.from(previewInputs).map(async (input) => {
      if (!input.value) return

      const index = input.name.match(/items\[(\d+)\]/)?.[1]
      if (!index) return

      try {
        const result = await this.uploadBase64ToWorker(input.value)

        if (result?.url) {
          const hidden = document.createElement('input')
          hidden.type = 'hidden'
          hidden.name = `items[${index}]properties[_Preview]`
          hidden.value = result.url
          hidden.dataset.preview = ''
          form.appendChild(hidden)
        }
      } catch (error) {
        console.error(`[Monogramming] preview upload failed for item ${index}:`, error)
      }

      // Clear base64 so it isn't sent to Shopify
      input.value = ''
    }))
  }

  async uploadBase64ToWorker (base64Data) {
    const blob = this.base64ToBlob(base64Data)
    const url = `https://olivia-von-halle.by-association-only.workers.dev/api/images?shop=${window.theme.permanentDomain}`

    const response = await fetch(url, {
      method: 'POST',
      body: blob,
      headers: { 'Content-Type': 'image/jpeg' },
    })

    if (!response.ok) {
      throw new Error(`Image upload failed with status: ${response.status}`)
    }

    return response.json()
  }

  base64ToBlob (base64Data, mimeType = 'image/jpeg') {
    const base64 = base64Data.replace(/^data:image\/[a-z]+;base64,/, '')
    const byteCharacters = atob(base64)
    const byteNumbers = new Uint8Array(byteCharacters.length)

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }

    return new Blob([byteNumbers], { type: mimeType })
  }

  setVariant () {
    const selectedVariant = document.querySelector('#product-select').value
    if (!selectedVariant) return

    this.els.id.element.value = selectedVariant
    this.externalEls['parent-id'].elements.forEach(el => {
      el.value = selectedVariant
    })
  }

  get currentStep () {
    return this._currentStep
  }

  set currentStep (step) {
    this._currentStep = step

    this.els.step?.elements.map(el => {
      el.setAttribute('aria-current', el.dataset.step === step)
    })
  }

  resetForm () {
    window.BAO.dispatchEvent(window.BAO.EVENTS.PERSONALISATION.RESET)
    
    this.currentStep = 'intro-1'

    const previewInputs = this.querySelectorAll(`[data-preview]`)

    previewInputs.forEach(input => {
      input.remove()
    })
  }
}

if (!customElements.get('product-monogramming')) {
  customElements.define('product-monogramming', ProductMonogramming)
}
